import React, { Component } from 'react';
import { round } from 'mathjs';
import currencyFormatter from 'currency-formatter';
import moment from 'moment';

class KucoinInterestBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collapse: 'expand',
    };
  }

  renderCurrency(currency) {
    let color = 'blue';
    if (currency == 'UST') {
      color = 'red';
      currency = 'USDT';
    } else if (currency == 'USD') {
      color = 'black';
    }
    return <span className={'badge bg-' + color}>{currency}</span>;
  }

  renderRow(data) {
    var rows = [];
    data.forEach((item, index) => {
      if (this.state.collapse == 'expand' && index > 9) {
        return true;
      }
      if (item.roi > 500) {
        item.roi = 0;
      }
      rows.push(
        <tr key={'in' + index}>
          <td style={{ textAlign: 'center' }}>{moment(item.timestamp * 1000).format('YYYY-MM-DD')}</td>
          <td style={{ textAlign: 'right' }}>
            {currencyFormatter.format(item.amount, {
              code: 'USD',
              precision: 4,
            })}
          </td>
        </tr>
      );
    });
    return rows;
  }

  render() {
    let data = JSON.parse(this.props.data);
    data = data.data.reverse();
    console.log(data);
    return (
      <div className="col-md-4">
        <div className="box box-info">
          <div className="box-header with-border">
            <h3 className="box-title">{this.props.coin ? this.props.coin : ''} 收入明細</h3>
            <div className="box-tools pull-right">
              <a
                href="#"
                style={{ color: '#fff', fontSize: 20 }}
                onClick={(e) => {
                  e.preventDefault();
                  if (this.state.collapse == 'expand') {
                    this.setState({ collapse: 'compress' });
                  } else {
                    this.setState({ collapse: 'expand' });
                  }
                }}
              >
                <i className={'fa fa-' + (this.state.collapse == 'expand' ? 'chevron-down' : 'chevron-up')}></i>
              </a>
            </div>
          </div>
          <div className="box-body">
            <div className="table-responsive">
              <table className="table no-margin table-striped">
                <thead>
                  <tr>
                    <th style={{ textAlign: 'center' }}>日期</th>
                    <th style={{ textAlign: 'right' }}>累計金額</th>
                  </tr>
                </thead>
                <tbody>{this.renderRow(data)}</tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default KucoinInterestBox;
